import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const apiurl = "https://api.stockastix.com";

// Async thunk to fetch annotations for a given user
export const fetchAnnotations = createAsyncThunk(
  'workbench/fetchAnnotations',
  async (_, { getState, rejectWithValue }) => {
    const token = getState()?.auth?.accessToken;
    try {
      const response = await axios.get(`${apiurl}/annotations/get-annotations`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data.annotations;  // Returning annotations object
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.error);
      }
      return rejectWithValue('Failed to fetch annotations.');
    }
  }
);

// Async thunk to add annotations for a given user
export const addAnnotations = createAsyncThunk(
  'workbench/addAnnotations',
  async (data, { getState, rejectWithValue }) => {
    const token = getState()?.auth?.accessToken;
    try {
      await axios.post(`${apiurl}/annotations/add-annotations/`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return { status: 200 }; 
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.error);
      }
      return rejectWithValue('Failed to add annotations.');
    }
  }
);

const workbenchSlice = createSlice({
  name: 'workbench',
  initialState: {
    annotations: {},  // Store annotations as an object with tickers as keys
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnnotations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAnnotations.fulfilled, (state, action) => {
        state.loading = false;
        state.annotations = action.payload;  // Store the fetched annotations
      })
      .addCase(fetchAnnotations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addAnnotations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAnnotations.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addAnnotations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default workbenchSlice.reducer;
